import React from "react"

import useGetDeviceFormDataFromApiResponse from "./useGetDeviceFormDataFromApiResponse"
import { TTRDeviceFormData } from "../components/devices/ttr/types/providerTypes"
import { AppError } from "../errors/errorProcessors"
import { TTTRDeviceResponseType } from "../services/middleware/types/devices/ttr/publishDeviceTypes"
import {
    getEmptyTTRDeviceFormData,
    mapDeviceResponseToDeviceFormData,
} from "../utils/registerDevice/registerDeviceUtils"

interface IUseGetTTRDeviceFormDataFromApiResponseOutput {
    formData: TTRDeviceFormData
    setFormData: React.Dispatch<React.SetStateAction<TTRDeviceFormData>>
}

const useGetTTRDeviceFormDataFromApiResponse = <
    T extends TTTRDeviceResponseType,
>(
    isLoading: boolean,
    isValidating: boolean,
    error?: AppError,
    response?: T
): IUseGetTTRDeviceFormDataFromApiResponseOutput =>
    useGetDeviceFormDataFromApiResponse(
        mapDeviceResponseToDeviceFormData,
        getEmptyTTRDeviceFormData,
        isLoading,
        isValidating,
        error,
        response
    )

export default useGetTTRDeviceFormDataFromApiResponse
